import { ButtonType, DialogFooterButtonsWidget } from '@tableau/widgets';
import * as React from 'react';
import { connect } from 'react-redux';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';
import { DialogFieldParentStyle } from '~src/commonInfra/dialogs/style/DialogStyles';


export interface KMSKeyRestoreForbiddenViewOwnProps {
    closeDialog: CloseAndDismiss;
}

export type KMSKeyRestoreForbiddenViewProps = KMSKeyRestoreForbiddenViewOwnProps;


export interface KMSKeyRestoreForbiddenViewState {
}

export class KMSKeyRestoreForbiddenViewComponent extends React.PureComponent<KMSKeyRestoreForbiddenViewProps, KMSKeyRestoreForbiddenViewState> {

    constructor(props: KMSKeyRestoreForbiddenViewProps) {
        super(props);
    }


    public render(): JSX.Element {
        return <>
            <div style={DialogFieldParentStyle}>{Messages.credentialEncryption_KMSKeyRestoreForbidden_Description()}</div>
            <br></br>
            <div style={{ position: 'relative' }}>
                <DialogFooterButtonsWidget
                    buttons={[
                        {
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            onClick: this.props.closeDialog.close,
                            testId: 'cancel-button'
                        },
                    ]}
                />
            </div>
        </>;
    }
}

export const KMSKeyRestoreForbiddenView: React.ComponentClass<KMSKeyRestoreForbiddenViewOwnProps> =
  connect(undefined, undefined)(KMSKeyRestoreForbiddenViewComponent);